import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row, Card, CardBody } from 'reactstrap';

import { Input, Checkbox } from '@/components/form';
import ResourceForm from '@/components/resources/form';
import View from '@/components/view';
import { t } from '@/services/translator';

const TypeForm = ({ match }) => {
  const isEditMode = ({ resource }) => {
    if (!resource) {
      return true;
    }

    if (!resource.mappings) {
      return true;
    }

    return !resource.mappings.update;
  };

  return (
    <View>
      <ResourceForm resource="PartnerType" id={match.params.id} initialValues={{ key: '' }}>
        {({ submitting, renderActions, values, ...args }) => (
          <>
            <Card>
              <CardBody className={submitting ? 'loading' : ''}>
                <Row>
                  <Col lg={6}>{isEditMode(args) ? <Input name="key" /> : values.key && t(values.key)}</Col>
                  <Col lg={6}>
                    <Checkbox name="auto" />
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <div className="mt-4 mb-4">{renderActions()}</div>
          </>
        )}
      </ResourceForm>
    </View>
  );
};

TypeForm.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({ id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) })
  }).isRequired
};

export default TypeForm;
